module.exports = __webpack_public_path__ + "static/img/balance_pay2.10eafd71.jpg";